const colors = [
	'#13F6BC',
	'#F7B117',
	'#EC0FB0',
	'#DF525B',
	'#C636FA',
	'#F8733B',
	'#EA3D2D',
	'#0C5AF3',
	'#0AFFA0',
	'#6400CB',
	'#E9FD76',
	'#43FE18',
	'#FEB42B',
	'#C7FF09',
	'#31FEA9',
	'#06E7B8',
	'#FD308F',
	'#D152B4',
	'#A22AF0',
	'#F4F92B',
]

export default function RandomColors() {
	return colors[Math.floor(Math.random() * colors.length)]
}
